import { baseApi } from "../api";

export const pwaAPI = baseApi.injectEndpoints({
	endpoints: (builder) => ({
		getRewardPWA: builder.query({
			query: () => "/rest/pwa/incentive-reward",
			providesTags: () => [{ type: "PWARewardTag" }]
		}),
		getRewardStatusPWA: builder.query({
			query: () => "/rest/pwa/rewarded",
			providesTags: () => [{ type: "PWARewardStatusTag" }]
		}),
		launchPWA: builder.mutation({
			query: (arg) => {
				const queryParams = new URLSearchParams();
				for (const key in arg.body) {
					queryParams.append(key, arg.body[key]);
				}
				return {
					url: `/rest/pwa/launched?${queryParams.toString()}`,
					method: "POST"
				};
			},
			invalidatesTags: () => [{ type: "PWARewardStatusTag" }]
		}),
		pushSubscriptionPWA: builder.mutation({
			query: (subscription: PushSubscription) => ({
				url: "/rest/pwa/push-subscription",
				method: "POST",
				body: { data: subscription }
			})
		})
	})
});

export const {
	useGetRewardPWAQuery,
	useGetRewardStatusPWAQuery,
	useLaunchPWAMutation,
	usePushSubscriptionPWAMutation
} = pwaAPI;
